module.exports = __webpack_public_path__ + "img/modelo_small.15468d6e.gif";